<script lang="ts">
	import PageHeader from '$lib/components/page-header.svelte';
	import Posts from '$lib/components/posts.svelte';
	import { appName, blogBaseUrl } from '$lib/meta';
	import type { PageData } from './$types';

	export let data: PageData;
	export const { posts } = data;
</script>

<svelte:head>
	<title>Blog Posts | {appName}</title>
	<meta
		name="description"
		content="All blog posts by Dániel Sipos — practical guides on Docker, TypeScript, React Native, and more."
	/>

	{@html `<script type="application/ld+json">${JSON.stringify({
		'@context': 'https://schema.org',
		'@type': 'ItemList',
		itemListElement: posts.map((post, i) => ({
			'@type': 'ListItem',
			position: i + 1,
			url: `${blogBaseUrl}${post.path}`,
			name: post.metadata.title
		}))
	})}</script>`}
</svelte:head>

<section>
	<PageHeader>Posts</PageHeader>
	<Posts {posts} />
</section>
